export default {"src":"/_next/static/media/Urology.ff9a0ef2.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};